import React from 'react'
import Sidebar from '../../components/Structure/Sidebar'

function SettingsPage({studentId}) {
    return (
        <div className='d-md-flex' style={{ height: '100vh' }}>
            {/* left section */}
            <Sidebar />

            {/* right section */}

            <div className='col-12 col-md-9 px-4 rounded-4 d-flex flex-column overflow-auto linear-background-color' >
                <div className='my-auto mx-auto text-success '>
                    <h1 className='fw-bold animate__animated animate__pulse'>Under Construction: Big Surprises Loading! 😉</h1>
                </div>
            </div>
        </div>
    )
}

export default SettingsPage